import moment from 'moment-timezone';

const dateParserDatabaseFormat = (date) => {
  const parsedDate = moment(date).tz('Asia/Jakarta').format();

  return parsedDate;
};

export default dateParserDatabaseFormat;
